import React, { useState, useEffect } from 'react';
import { saveToLocalStorage, getFromLocalStorage } from './util';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 20px 0;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.div`
  color: rgb(75, 40, 109);
  margin-bottom: 0.5rem;
  font-weight: 700;
`;

const TitleAdded = styled.div`
  color: rgb(75, 40, 109);
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
`;

const Input = styled.input`
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 0.75rem 2rem;
  margin: 5px 0;
  border: none;
  border-radius: 4px;
  background-color: #2b8000;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  border: 1px solid #2b8000;

  &:hover {
    background-color: #fff;
    color: #2b8000;
    border: 1px solid #2b8000;
  }

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  background: #ffffff;
  padding: 15px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 10px;
`;

const OptionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style-type: disc;
  padding: 0.5rem 0;
`;

const OptionListItem = styled.li`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const AddButtonContainer = styled.div`
  margin-top: 10px;
`;

const GridBox = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr;
  column-gap: 1rem;
`;

const Strong = styled.div`
  font-weight: 700;
`;

const StrongSpan = styled.span`
  font-weight: 700;
`;

const QuestionForm = () => {
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState([
    { text: '', monthlyPrice: '', dueNowPrice: '' }
  ]);
  const [questionsList, setQuestionsList] = useState([]);

  useEffect(() => {
    const existingQuestions = getFromLocalStorage('questions') || [];
    setQuestionsList(existingQuestions);
  }, []);

  const handleOptionChange = (index, field, value) => {
    const newOptions = [...options];
    newOptions[index][field] = value;
    setOptions(newOptions);
  };

  const handleAddOption = () => {
    setOptions([...options, { text: '', monthlyPrice: '', dueNowPrice: '' }]);
  };

  const handleSubmit = () => {
    const existingQuestions = getFromLocalStorage('questions') || [];
    const newQuestion = { question, options };
    const updatedQuestions = [...existingQuestions, newQuestion];
    saveToLocalStorage('questions', updatedQuestions);
    setQuestionsList(updatedQuestions);
    setQuestion('');
    setOptions([{ text: '', monthlyPrice: '', dueNowPrice: '' }]);
  };

  return (
    <Container>
      <Title>Add individual Question</Title>
      <Section>
        <Input
          type="text"
          value={question}
          onChange={e => setQuestion(e.target.value)}
          placeholder="Question"
        />
        {options.map((option, index) => (
          <GridBox key={index}>
            <Input
              type="text"
              value={option.text}
              onChange={e => handleOptionChange(index, 'text', e.target.value)}
              placeholder="Option"
            />
            <Input
              type="number"
              value={option.monthlyPrice}
              onChange={e =>
                handleOptionChange(index, 'monthlyPrice', e.target.value)
              }
              placeholder="Monthly Price"
            />
            <Input
              type="number"
              value={option.dueNowPrice}
              onChange={e =>
                handleOptionChange(index, 'dueNowPrice', e.target.value)
              }
              placeholder="Due Now Price"
            />
          </GridBox>
        ))}
        <AddButtonContainer>
          <Button onClick={handleAddOption}>Add Option</Button>
        </AddButtonContainer>
        <AddButtonContainer>
          <Button onClick={handleSubmit}>Save Question</Button>
        </AddButtonContainer>
      </Section>

      <Section>
        <TitleAdded>Added Questions</TitleAdded>
        <List>
          {questionsList.map((q, index) => (
            <ListItem key={index}>
              <Strong>{q.question}</Strong>
              <OptionList>
                {q.options.map((option, optIndex) => (
                  <OptionListItem key={optIndex}>
                    <StrongSpan>{option.text}</StrongSpan>
                    <span style={{ fontSize: '14px' }}>
                      ( Monthly -{' '}
                      <StrongSpan>${option.monthlyPrice}</StrongSpan>, Due Now -
                      <StrongSpan>${option.dueNowPrice}</StrongSpan> )
                    </span>
                  </OptionListItem>
                ))}
              </OptionList>
            </ListItem>
          ))}
        </List>
      </Section>
    </Container>
  );
};

export default QuestionForm;
